/* ***** ----------------------------------------------- ***** **
** ***** Post JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, soundManager, _taboola */
(function($){
	'use strict';

	Main.modules.post = function() {

		var $body = $('body'),
			$postPreviewFeaturedMainNews = $('.o-post_preview--featured_main--news'),
			$playVideo = $('.js-play_video'),
			$postHeader = $('.c-post_header'),
			$postHeaderVideo = $('.c-post_header-video'),
			currentHref = location.href,
			utilities = Main.modules.utilities(),
			isMediumWidth = utilities.isMediumWidth(),
			postPreviewFeaturedMainNewsHeight,

			featuredMainNewsArticleSetHeight = function() {

				// If viewed on a tablet, get the height of the article and it to that height
				// Prevents text from overflowing and forces the image to display at full height
				$postPreviewFeaturedMainNews.css('height', '');

				if (isMediumWidth) {
					postPreviewFeaturedMainNewsHeight = $postPreviewFeaturedMainNews.height();
					$postPreviewFeaturedMainNews.css('height', postPreviewFeaturedMainNewsHeight);
				}

			},

			playVideo = function() {

				$playVideo.on('click', function() {

					var $currentTrack = $('.c-header_audio_player_playlist li.current'),
						currentTrackID = $currentTrack.data('track_id'),
						videoData = $postHeaderVideo.data('video'),
						videoType = videoData.type,
						videoID = videoData.id;

					// If a track in the header player is playing, pause it 
					if ($currentTrack.length) {
						soundManager.getSoundById(currentTrackID).pause();
					}

					// Append video embed to container based on type
					if (videoType == 'YouTube') {
						$postHeaderVideo.append('<iframe src="https://www.youtube.com/embed/' + videoID + '?autoplay=1&autohide=1&controls=1&loop=0&wmode=transparent&showinfo=0&modestbranding=0" frameborder="0" allowfullscreen></iframe>');
					} else {
						$postHeaderVideo.append('<iframe src="https://player.vimeo.com/video/' + videoID + '?autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
					}

					$postHeader.addClass('c-post_header--video_is_playing');

				});

			},

			responsiveVideoWrap = function() {

				// For all YouTube or Vimeo embeds on page, wrap with container to allow embed to be responsive
				if ($body.hasClass('single-post')) {
					$('.c-post-content iframe[src*="youtube"], .c-post-content iframe[src*="vimeo"]').each(function() {
						
						var $this = $(this);
						$this.wrap('<div class="o-video_embed"></div>');

					});
				}

			},

			initializeTaboola = function() {

				// On initial page load on a post page, load Taboola widget
				_taboola.push({
					mode: 'thumbnails-a',
					container: 'taboola-below-article-thumbnails',
					placement: 'Below Article Thumbnails',
					target_type: 'mix'
				});

				_taboola.push({
					article: 'auto',
					url: currentHref
				});

			},

			reinitializeTaboola = function() {

				// On reinitialize Taboola widget when loading a new page
				_taboola.push({
					notify: 'newPageLoad'
				});

				_taboola.push({
					mode: 'thumbnails-a',
					container: 'taboola-below-article-thumbnails',
					placement: 'Below Article Thumbnails',
					target_type: 'mix'
				});

				_taboola.push({
					article: 'auto',
					url: currentHref
				});

			};

		return {
			init: function() {
				if ($body.hasClass('single')) {
					playVideo();
					responsiveVideoWrap();
					initializeTaboola();
				} else if ($body.hasClass('category-news')) {
					featuredMainNewsArticleSetHeight();
				}
			},
			featuredMainNewsArticleSetHeight: featuredMainNewsArticleSetHeight,
			playVideo: playVideo,
			responsiveVideoWrap: responsiveVideoWrap,
			reinitializeTaboola: reinitializeTaboola
		}
		
	};

})(jQuery);